export enum CSCS_UPLOAD_STATUS {
	SUBMITTED_AND_APPROVED = "SUBMITTED_AND_APPROVED",
	SUBMISSION_NOT_APPROVED = "SUBMISSION_NOT_APPROVED",
	FAILED = "FAILED",
	PENDING_UPLOAD = "PENDING_UPLOAD",
}
